module.exports = __webpack_public_path__ + "static/media/sort-filter-icon-active.9fcae87a.svg";